import type { IconProps } from '../../../components/Icon/Icon.util';

export const Privacy = ({
  title,
  width = 32,
  height = 32,
  fill = 'none',
  role = 'presentation',
}: IconProps): React.ReactNode => {
  const viewBoxSize = 32;

  return (
    <svg
      fill={fill}
      focusable='false'
      height={height}
      role={role}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      {title ? <title>{title}</title> : null}

      <path
        clipRule='evenodd'
        d='M15.9981 7.00132C21.4323 6.92115 26.8681 10.5119 30.2079 14.0278L30.2112 14.0312C30.719 14.571 31 15.2717 31 15.9982C31 16.7247 30.719 17.4254 30.2112 17.9652L30.2083 17.9683C26.9446 21.4074 21.5221 25.0801 15.9981 24.9987C10.4741 25.0801 5.05282 21.4073 1.79147 17.968L1.78881 17.9652C1.28101 17.4254 1 16.7247 1 15.9982C1 15.2717 1.28101 14.571 1.78882 14.0312L1.79167 14.0282C5.12814 10.5118 10.5639 6.92115 15.9981 7.00132ZM3.27363 15.3141C3.09746 15.502 3 15.7457 3 15.9982C3 16.2508 3.0975 16.4945 3.27372 16.6824C6.39073 19.9688 11.3073 23.1591 15.9813 23.0837C15.9925 23.0836 16.0037 23.0836 16.015 23.0837C20.689 23.1591 25.6068 19.9688 28.7264 16.6822C28.9025 16.4943 29 16.2507 29 15.9982C29 15.7458 28.9026 15.5022 28.7266 15.3144C25.5389 11.9595 20.6071 8.84208 16.015 8.91625C16.0038 8.91643 15.9925 8.91643 15.9813 8.91625C11.3891 8.84208 6.45721 11.9596 3.27363 15.3141Z'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20ZM16 22C19.3137 22 22 19.3137 22 16C22 12.6863 19.3137 10 16 10C12.6863 10 10 12.6863 10 16C10 19.3137 12.6863 22 16 22Z'
        fillRule='evenodd'
      />
    </svg>
  );
};
